import type {ReactElement, ReactNode} from 'react';
import {useRef} from 'react';
import {AiChatProvider} from '@AiChat/providers/ai-chat-provider';
import {AiChatCallbacksProvider} from '@AiChat/callbacks/ai-chat-callbacks-provider';
import {aiChatSizeContext, useMeasuredAiChatSize} from '@AiChat/hooks/useAiChatSize';
import {toAiChatProviderProps} from '@AiChat/ai-chat.library';
import type {AiChatRootProps} from '@AiChat/ai-chat-root.types';
import styles from './ai-chat-root.module.scss';

export function AiChatRoot({chatProps, isEmbedded, presentation, chatId, callbacks, children}: AiChatRootProps): ReactElement {
  const containerRef = useRef<HTMLDivElement>(null);
  const size = useMeasuredAiChatSize(containerRef);
  const ownsTheViewport = !isEmbedded;

  const renderChat = (): ReactNode => {
    if (!size) {
      return null;
    }

    return (
      <aiChatSizeContext.Provider value={size}>
        <AiChatCallbacksProvider callbacks={callbacks}>
          <AiChatProvider {...toAiChatProviderProps(chatProps)} isEmbedded={isEmbedded} presentation={presentation} chatId={chatId}>
            {children}
          </AiChatProvider>
        </AiChatCallbacksProvider>
      </aiChatSizeContext.Provider>
    );
  };

  return (
    <div ref={containerRef} className={`${styles.container} ${ownsTheViewport ? styles.fullScreenContainer : ''}`}>
      {renderChat()}
    </div>
  );
}
